<div class="main-page-container">
  <div class="sticky-top">
    <div class="title-container padding-x">
      <p class="title mb-0">Create Itinerary</p>
    </div>

    <div class="navbar-list-container padding-x">
      <div class="item">
        <p class="link">Trip Details</p>
      </div>
      <div class="item">
        <p class="link active">AI Route Plan</p>
      </div>
      <div class="item">
        <p class="link">Hotels</p>
      </div>
      <div class="item">
        <p class="link">Vehicles</p>
      </div>
      <div class="item">
        <p class="link">Review</p>
      </div>
      <div class="item">
        <p class="link">Pricing</p>
      </div>
      <div class="item">
        <p class="link">Payment</p>
      </div>
      <div class="item">
        <p class="link">Confirmation</p>
      </div>
    </div>
  </div>

  <div class="page-main-section padding-x pt-4">
    <div class="route-craft-main-container">
      <div class="main-title-container">
        <!-- <p class="title">Days <span class="fw-bold">2</span> | Total Distances <span class="fw-bold">145 km</span>  | Travel Time <span class="fw-bold">4 hr 20 min</span> </p> -->
         <p class="title">{{routeTitle}}</p>
      </div>

      <div class="route-craft">
        <div class="day-route-item" *ngFor="let item of aiDaysArray; index as i">
          <div class="title">Day {{i+1}} | {{getDayDate(i)}}</div>
          <div class="input-container">
            <input type="text" class="input w-100" [value]="item.header">
          </div>
          <div class="data-container input-container">
            <app-text-formatting-input [inputHeight]="'md'" [value]="item.contentString"></app-text-formatting-input>
          </div>
        </div>
      </div>
    </div>

    <div class="map-main-container h-100">
      <div class="h-100">
        <app-mapview></app-mapview>
      </div>
    </div>
  </div>

  <div class="footer-main-container">
    <div class="d-flex justify-content-center">
      <ion-button class="unfilled-blue-btn">Share For Feedback</ion-button>
      <ion-button class="filled-blue-btn submit-btn" (click)="onSubmit()">Continue To Hotels</ion-button>
    </div>
  </div>
</div>